<mat-card style="border-width: 0; width: 300px">
  <card-header [label]="'SETTINGS.SETTINGS' | translate" (onClose)="hide()"></card-header>
  <mat-card-content>
    <div *ngIf="isAdmin()" fxLayout="row" fxLayoutAlign="space-evenly center">
      <label fxFlex="50%">{{'SETTINGS.SYMBOLS_SIZE' | translate}}</label>
      <mat-slider [disabled]="autoSymbolsSize" fxFlex="50%" thumbLabel tickInterval="{{(maxSymbolsSize()-minSymbolsSize())}}"
        step="0.1" min="{{minSymbolsSize()}}" max="{{maxSymbolsSize()}}" [(ngModel)]="symbolsSize"
        (change)="onSymbolsSizeSliderChanged($event)">
      </mat-slider>
    </div>
    <div *ngIf="isAdmin()" fxLayout="row" fxLayoutAlign="space-evenly center">
      <mat-checkbox [(ngModel)]="autoSymbolsSize" (change)="autoSizeChange($event)">
        <div class="show-dtm-checkbox">{{'SETTINGS.AUTOSIZE' | translate}}</div>
      </mat-checkbox>
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <label fxFlex="50%" >{{'SETTINGS.DISPLAY_UNITS' | translate}}</label>
      <mat-select fxFlex="50%" [value]="displayUnits"
        (selectionChange)="onDisplayUnitsSelected($event)">
        <mat-option class="mat-option-compact" *ngFor="let du of allDisplayUnits" [value]="du.id">{{du.title}}
        </mat-option>
      </mat-select>
    </div>
    <mat-divider></mat-divider>
    <!-- <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <label fxFlex="50%">{{'SETTINGS.LANGUAGE' | translate}}</label>
      <mat-select fxFlex="50%" class="display-language-select" [value]="selectedLanguage" (selectionChange)="setLanguage($event)">
        <mat-option class="mat-option-compact" *ngFor="let language of languages" [value]="language.id">{{language.title}}
        </mat-option>
      </mat-select>
    </div>
    <mat-divider></mat-divider> -->
    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <mat-checkbox (change)="saveDTMChecked($event)">
        <div class="show-dtm-checkbox">{{'SETTINGS.SHOW_DTM' | translate}}</div>
      </mat-checkbox>
    </div>
    <!-- <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <button mat-button color="warn" (click)="resetSystem()">{{'SETTINGS.RESET_LOCAL_DATA' | translate}}</button>
    </div> -->
    <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <label  fxFlex="65%">Receive Notifications</label>
      <mat-checkbox [(ngModel)]="notifications.alerts" fxFlex="35%" (change)="toggleAlerts()">
        <div class="show-dtm-checkbox">Alerts</div>
      </mat-checkbox>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <label  fxFlex="30%">Azimuth:</label>
      <mat-checkbox  [(ngModel)]="notifications.videoAzimuth" fxFlex="35%" (change)="toggleVideoAzimuth()">
        <div class="show-dtm-checkbox">Video</div>
      </mat-checkbox>
      <mat-checkbox  [(ngModel)]="notifications.sensorAzimuth" fxFlex="35%" (change)="toggleSensorAzimuth()">
        <div class="show-dtm-checkbox">Sensors</div>
      </mat-checkbox>
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutAlign="space-evenly center">
      <button mat-button color="basic" (click)="getAbout()" matTooltip='{{verString}}' matTooltipClass="allow-cr">{{'SETTINGS.ABOUT' | translate}}</button>
    </div>
  </mat-card-content>
</mat-card>